// SAFE-WRITE-BEGIN: frontend/src/pages/valuation/_overviewNext.ts
/**
 * VAL-WALK-POLISH-3 P4 — the Overview card's Next line names the first
 * unfinished step in step-bar order (Company, Financials, Review and adjust),
 * then falls back to the shared nextStep() answer. Left nav is not touched.
 */
import type { NextStep } from './_nextStep'

export interface OverviewFacts {
  hasCompanyProfile: boolean
  /** null = unknown (the fetch failed); falls through. */
  yearCount: number | null
  /** null = unknown (the fetch failed); falls through. */
  adjustApplied: boolean | null
}

export function overviewNextStep(
  step: NextStep,
  id: string,
  status: string,
  facts: OverviewFacts,
): NextStep {
  const base = `/valuation/${id}`
  // Only the "go to Intake" answers are refined; later steps stand as they are.
  if (step.route !== `${base}/intake` || status === 'intake_in_progress') return step
  if (!facts.hasCompanyProfile) return { label: 'Company', route: `${base}/company` }
  if (facts.yearCount === 0) return { label: 'Financials', route: `${base}/financials` }
  if (facts.adjustApplied === false) return { label: 'Review and adjust', route: `${base}/adjust` }
  return step
}
// SAFE-WRITE-EOF: frontend/src/pages/valuation/_overviewNext.ts
